// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonFilters = {
  all: "すべて",
  createdBy: "作成者",
  updatedBy: "更新者",
} as const;
